<template>
  <div id="scenePhoto" class="animated fadeIn h-100">
    <b-row class="h-100">
      <b-col class="cont">
        <b-row class="h-100">
          <b-col class="col-12">
            <b-card
              class="h-100 default-border1"
              body-class="h-100 p-0"
              header-tag="header"
            >
              <h6 slot="header">현장 사진</h6>
              <div class="searchBox h60 p15">
                <div>
                  <label>구조물</label>
                  <b-form-select
                    v-model="search.stid"
                    :options="search.stidOptions"
                    @change="changeStId"
                    required
                  ></b-form-select>
                  <label>디바이스</label>
                  <b-form-select
                    v-model="search.device"
                    :options="search.deviceOptions"
                  ></b-form-select>
                  <label>모드</label>
                  <b-form-select
                    v-model="search.photoType"
                    :options="search.photoTypeOptions"
                  ></b-form-select>
                  <label>기간</label>
                  <b-form-input
                    type="date"
                    v-model="search.startDate"
                    :max="search.endDate"
                    required
                  ></b-form-input>
                  <label>~</label>
                  <b-form-input
                    type="date"
                    v-model="search.endDate"
                    :min="search.startDate"
                    required
                  ></b-form-input>
                  <label>시간</label>
                  <div class="time" style="margin-left: 5px">
                    <input
                      class="time-input"
                      type="number"
                      min="0"
                      max="23"
                      v-model="search.startHour"
                      placeholder="00"
                      @change="
                        search.startHour = changeTime(search.startHour, 'h')
                      "
                      required
                    />
                    <!-- <input class="time-input" type="number" min="0" max="59" v-model="search.startMinute" placeholder="00" @change="search.startMinute = changeTime(search.startMinute, 'm')" required> -->
                  </div>
                  <label>~</label>
                  <div class="time">
                    <input
                      class="time-input"
                      type="number"
                      min="0"
                      max="23"
                      v-model="search.endHour"
                      placeholder="00"
                      @change="search.endHour = changeTime(search.endHour, 'h')"
                      required
                    />
                    <!-- <input class="time-input" type="number" min="0" max="59" v-model="search.endMinute" placeholder="00" @change="search.endMinute = changeTime(search.endMinute, 'm')" required> -->
                  </div>
                </div>
                <div>
                  <b-button
                    class="searchBtn"
                    @click="getData"
                    :disabled="search.stid == null"
                    >조회</b-button
                  >
                  <b-button
                    class="excelBtn"
                    @click="openVideo"
                    :disabled="videoFilePath == null"
                    >동영상</b-button
                  >
                </div>
              </div>
              <div class="body">
                <div class="time-line unfold">
                  <!-- <div class="title">
                    TimeLine
                  </div> -->
                  <div class="body">
                    <div
                      class="content"
                      v-for="(item, idx) in deviceCarmeraPics"
                      :key="idx"
                    >
                      <div class="pic-layout">
                        <div v-if="idx % 2 === 0">
                          <div class="pic-box" @click="showDetailPicture(item)">
                            <div class="pic-title">
                              <span class="mode">{{ item.mode }}</span>
                            </div>
                            <img class="pic-img" :src="item.base64Image" />
                            <div class="pic-date">
                              {{ item.pictime }}
                            </div>
                          </div>
                          <div class="pic-line odd"></div>
                        </div>
                      </div>

                      <div class="pic-num odd" v-if="idx % 2 === 0">
                        {{ idx }}
                      </div>
                      <div class="pic-num even" v-if="idx % 2 === 1">
                        {{ idx }}
                      </div>

                      <div class="pic-layout">
                        <div v-if="idx % 2 === 1">
                          <div class="pic-line even"></div>
                          <div class="pic-box" @click="showDetailPicture(item)">
                            <div class="pic-title">
                              <span class="mode">{{ item.mode }}</span>
                            </div>
                            <img class="pic-img" :src="item.base64Image" />
                            <div class="pic-date">
                              {{ item.pictime }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="selectedPic" class="detail-pic">
                  <div class="title">상세 정보</div>
                  <div class="body">
                    <div class="fold">
                      <b-button class="foldBtn" @click="closeDetailPicture"
                        ><i class="fas fa-angle-double-right"></i
                      ></b-button>
                    </div>
                    <div class="content">
                      <img :src="selectedPic.base64Image" />
                      <div class="option">
                        <b-button class="blueBtn" @click="showBigSizeImage"
                          ><i class="fas fa-search-plus"></i>크게보기</b-button
                        >
                        <b-button class="greenBtn" @click="downloadImage"
                          ><i class="fas fa-download"></i>다운로드</b-button
                        >
                      </div>
                      <!-- <div class="info"> -->
                      <div
                        style="
                          color: #b4b7bd;
                          font-size: 23px;
                          font-weight: 900;
                        "
                      >
                        <ul>
                          <li>구조물: {{ selectedPic.stname }}</li>
                          <li>
                            디바이스: {{ selectedPic.devicename }} /
                            {{ selectedPic.deviceid }}
                          </li>
                          <li>촬영 시간: {{ selectedPic.pictime }}</li>
                          <li>모드: {{ selectedPic.modename }}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="isBigSizeImg"
                  class="big-size-img"
                  @click="closeBigSizeImage"
                >
                  <img :src="selectedPic.base64Image" />
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      id="scenePhotoVideoModal"
      title="현장 동영상"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <scene-photo-video-modal
        :videoFilePath="videoFilePath"
      ></scene-photo-video-modal>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import ScenePhotoVideoModal from "./ScenePhotoVideoModal";

export default {
  components: {
    ScenePhotoVideoModal,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
    ]),
  },
  data() {
    return {
      search: {
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        device: null,
        deviceOptions: [{ value: null, text: "전체" }],
        photoType: null,
        photoTypeOptions: [
          { value: null, text: "전체" },
          { value: "P", text: "주기" },
          { value: "E", text: "이벤트" },
        ],
        startDate: null,
        endDate: null,
        startHour: "00",
        startMinute: "00",
        endHour: "00",
        endMinute: "00",
      },
      deviceCarmeraPics: [],
      selectedPic: null,
      videoFilePath: null,
      mouseEvent: {
        photoDiv: null,
        isDown: false,
        startX: null,
        scrollLeft: null,
      },
      timeLineDiv: null,
      isBigSizeImg: false,
    };
  },
  created() {
    this.getStidList();

    if (this.getSelectedDataStid) {
      this.search.stid = this.getSelectedDataStid;
      this.getDeviceId();
    }
  },
  mounted() {
    this.search.startDate = moment().add(-7, "day").format("YYYY-MM-DD");
    this.search.endDate = moment().format("YYYY-MM-DD");
    this.timeLineDiv = document.querySelector(".time-line");
    this.mouseEvent.photoDiv = document.querySelector(".time-line .body");

    if (this.getSelectedDataStartDate) {
      this.search.startDate = this.getSelectedDataStartDate;
    }
    if (this.getSelectedDataEndDate) {
      this.search.endDate = this.getSelectedDataEndDate;
    }
    this.addMouseMoveEvent();
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    addMouseMoveEvent() {
      this.mouseEvent.photoDiv.addEventListener("mousedown", (e) => {
        this.mouseEvent.isDown = true;
        this.mouseEvent.photoDiv.classList.add("active");
        this.mouseEvent.startX = e.pageX - this.mouseEvent.photoDiv.offsetLeft;
        this.mouseEvent.scrollLeft = this.mouseEvent.photoDiv.scrollLeft;
      });
      this.mouseEvent.photoDiv.addEventListener("mouseleave", () => {
        this.mouseEvent.isDown = false;
        this.mouseEvent.photoDiv.classList.remove("active");
      });
      this.mouseEvent.photoDiv.addEventListener("mouseup", () => {
        this.mouseEvent.isDown = false;
        this.mouseEvent.photoDiv.classList.remove("active");
      });
      this.mouseEvent.photoDiv.addEventListener("mousemove", (e) => {
        if (!this.mouseEvent.isDown) return;

        e.preventDefault();
        const x = e.pageX - this.mouseEvent.photoDiv.offsetLeft;
        const walk = (x - this.mouseEvent.startX) * 2;
        this.mouseEvent.photoDiv.scrollLeft = this.mouseEvent.scrollLeft - walk;
      });
    },
    changeStId() {
      this.getDeviceId();
    },
    changeTime(value, type) {
      if (value.length >= 2) {
        if (Number(value) < 0) {
          value = "00";
        } else {
          if (type === "h") {
            if (Number(value) > 23) value = "00";
          } else {
            if (Number(value) > 59) value = "00";
          }
        }
      }
      if (value.length === 1) value = "0" + value;
      if (!value) value = "00";

      return value;
    },
    getStidList() {
      var reqBody = {};
      this.$http
        .post("/scenePhoto/getStidList", reqBody, { timeout: 20 * 1000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text:
                  data[i].projectname +
                  "/" +
                  data[i].groupname +
                  "/" +
                  data[i].stname,
              });
            }
            this.search.stidOptions = options;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceId() {
      var reqBody = {
        stid: this.search.stid,
      };
      this.$http
        .post("/scenePhoto/getDeviceId", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var devlist = res.data.data;
            var options = [{ value: null, text: "전체" }];
            for (let i = 0; i < devlist.length; i++) {
              options.push({
                value: devlist[i].deviceid,
                text: devlist[i].devicename,
              });
            }
            this.search.device = null;
            this.search.deviceOptions = options;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    init() {
      this.deviceCarmeraPics = [];
      this.videoFilePath = null;
      this.closeDetailPicture();
    },
    getData() {
      if (this.search.stid === null) return;

      this.init();
      let deviceid = this.search.device
        ? String(this.search.device).split("/")[1]
        : null;
      let startDate = moment(this.search.startDate).format("YYYYMMDD");
      let endDate = moment(this.search.endDate).format("YYYYMMDD");
      let startHour = this.search.startHour;
      let endHour = this.search.endHour;
      let isTime = true;

      if (startHour === "00" && endHour === "00") {
        isTime = null;
      }

      let reqBody = {
        stid: this.search.stid,
        deviceid: deviceid,
        startDate: startDate,
        endDate: endDate,
        startHour: startHour,
        endHour: endHour,
        isTime: isTime,
        photoType: this.search.photoType,
      };

      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.startDate);
      this.setSelectedDataEndDate(this.search.endDate);

      this.$http
        .post("/scenePhoto/getData", reqBody, { timeout: 20 * 1000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.deviceCarmeraPics = res.data.data.image;
            this.videoFilePath = res.data.data.videoFilePath;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showDetailPicture(item) {
      if (this.selectedPic && this.selectedPic.idx === item.idx) {
        this.closeDetailPicture();
      } else {
        this.selectedPic = item;
        this.timeLineDiv.classList.remove("unfold");
        this.timeLineDiv.classList.add("fold");
      }
    },
    closeDetailPicture() {
      this.selectedPic = null;
      this.timeLineDiv.classList.remove("fold");
      this.timeLineDiv.classList.add("unfold");
      this.isBigSizeImg = false;
    },
    showBigSizeImage() {
      this.isBigSizeImg = true;
    },
    closeBigSizeImage() {
      this.isBigSizeImg = false;
    },
    downloadImage() {
      var a = document.createElement("a");
      a.href = this.selectedPic.base64Image;
      a.download =
        this.selectedPic.idx +
        "_" +
        this.selectedPic.deviceid +
        "_" +
        this.selectedPic.mode +
        ".jpg";
      a.click();
    },
    openVideo() {
      this.$bvModal.show("scenePhotoVideoModal");
    },
  },
};
</script>

<style lang="scss">
#scenePhoto {
  padding: 15px;
  & .card {
    & .card-header {
      padding: 10px 15px;
      & h6 {
        font-size: 14px;
        line-height: unset;
        & label.autoRefresh {
          position: absolute;
          top: 7px;
          right: 92px;
          margin-bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
        }
        & select.autoRefresh {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 7px;
          right: 7px;
          width: 75px;
          height: 25px;
          padding: 0px 28px 1px 12px;
          border: 1px solid #404656;
          border-radius: 5px;
        }
      }
    }
  }
  & .searchBox {
    justify-content: space-between;
  }
  & .time {
    background-color: #283046;
    color: #b4b7bd !important;
    border: 1px solid #404656;
    border-radius: 5px;
    display: inline-flex;
    height: 100%;

    & input {
      border: none;
      background-color: #283046;
      color: #b4b7bd !important;
      text-align: center;
      width: 60px;
    }
  }
  & .body {
    display: flex;
    flex-direction: row;
    height: calc(100% - 40px);

    & .time-line {
      color: #f2f2f2;
      height: calc(100% - 45px);
      padding: 5px;

      & .title {
        border: 1px solid #404656;
        border-bottom: none;
        font-weight: 600;
        font-size: 14px;
        color: #b4b7bd;
        padding-left: 10px;
      }
      & .body {
        display: flex;
        flex-direction: row;
        overflow-x: auto;
        height: 100%;
        border: 1px solid #404656;
        padding: 10px;
        cursor: grab;
        transition: all 0.2s;
        transform: scale(1);
        will-change: transform;
        user-select: none;

        & .content {
          display: flex;
          flex-direction: column;
          align-items: center;
          align-self: center;

          & .pic-layout {
            display: flex;
            flex-direction: column;
            width: 150px;
            height: 260px;
            text-align: -webkit-center;

            & .pic-box {
              border: 1px solid #9fa2ab;
              box-shadow: inset 0px 0px 5px #fff;

              & .pic-title {
                border-bottom: 1px solid #9fa2ab;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;

                & .mode {
                  margin-left: 5px;
                  font-size: 18px;
                  color: #d563ea;
                }
              }
              & .pic-img {
                width: 148px;
                height: 100px;
                transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);
              }
              & .pic-date {
                border-top: 1px solid #9fa2ab;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;

                & .mode {
                  font-size: 15px;
                }
              }
              & .pic-img:hover {
                transform: translateY(0) scale(1.2);
              }
            }
            & .pic-line {
              width: 7px;
              height: 110px;
            }
          }
          & .pic-num {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
          }
          & .odd {
            background: #697186;
            box-shadow: inset 0px 0px 5px #fff;
            color: #fff;
          }
          & .even {
            background: #c0c4cc;
            box-shadow: inset 0px 0px 5px #000;
            color: #000;
          }
        }
      }
      & .body.active {
        cursor: grabbing !important;
        cursor: -webkit-grabbing !important;
        transform: scale(1.015) !important;
      }
    }
    & .time-line.fold {
      width: calc(100% - 550px);
    }
    & .time-line.unfold {
      width: 100%;
    }
    & .detail-pic {
      display: flex;
      flex-direction: column;
      border: 1px soild #404656 i !important;
      margin-top: 5px;
      height: calc(100% - 15px);

      & .title {
        border: 1px solid #404656;
        border-bottom: none;
        font-weight: 600;
        font-size: 14px;
        color: #b4b7bd;
        padding-left: 10px;
      }
      & .body {
        display: flex;
        flex-direction: row;
        border: 1px solid #404656;

        & .fold {
          width: 30px;
          align-self: center;
          z-index: 1;

          & .foldBtn {
            font-size: 18px;
            height: 130px;
            border: 1px solid #404656;
            border-left: none;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            color: #b4b7bd;
            background-color: #161d31;
            box-shadow: inset 0px 0px 5px #444d65;
          }
          & .foldBtn:hover {
            background-color: #222a42;
            box-shadow: inset 0px 0px 5px #6f7890;
          }
        }
        & .content {
          padding: 5px;

          img {
            width: 500px;
            height: 330px;
            margin-bottom: 15px;
          }
          & .option {
            display: flex;
            margin-bottom: 80px;
            justify-content: flex-end;

            button {
              color: #fff;
              border: 1px solid;
              border-radius: 5px;
              width: 130px;

              i {
                margin-right: 10px;
              }
            }
            & .blueBtn {
              background-color: #0071bb;
              border-color: #054d95;
              margin-right: 10px;
            }
            & .blueBtn:hover {
              background-color: #1685ce;
              border-color: #1159a0;
            }
            & .greenBtn {
              background-color: #207245;
              border-color: #207245;
            }
            & .greenBtn:hover {
              background-color: #348c5c;
              border-color: #328859;
            }
          }
          & .info {
            color: #b4b7bd;
            font-size: 23px;
            font-weight: 900;
          }
        }
      }
    }
    & .big-size-img {
      display: flex;
      position: absolute;
      width: 800px;
      height: 800px;
      right: 30%;
      background-color: #161d31;
      border: 1px solid #404656;
      border-radius: 7px;
      box-shadow: inset 0px 0px 5px #444d65;
      cursor: pointer;
      transition: all 0.2s;
      transform: scale(1);
      will-change: transform;
    }
    & .big-size-img:hover {
      transform: scale(1.02);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scene-photo/ScenePhoto.vue